// Elements Component
export const LOADER_LOADING_MESSAGE = (loadingMessage) =>
  loadingMessage || "Loading...";

export default {
  LOADER_LOADING_MESSAGE,
};
